<script lang="ts" setup>
import imgAdmirationUser1 from './admiration_user1.svg';
import imgAdmirationUser2 from './admiration_user2.svg';
import imgAdmirationUser3 from './admiration_user3.svg';

const images = {
  1: imgAdmirationUser1,
  2: imgAdmirationUser2,
  3: imgAdmirationUser3,
} as const;

const props = defineProps<{
  imageNumber: keyof typeof images;
}>();

const imageUrl = images[props.imageNumber];
</script>

<template>
  <div :class="$style.container">
    <div :class="[$style.container__title, $style.title]">
      <div :class="[$style.title__image, $style.image]">
        <img :src="imageUrl" alt="" loading="lazy" />
      </div>
      <p :class="[$style.title__text, $style.text]">
        <slot name="titleText" />
      </p>
    </div>
    <p :class="[$style.container__detail, $style.detail]">
      <slot name="detail" />
    </p>
  </div>
</template>

<style lang="scss" module>
.container {
  width: 100%;
  padding: 32px;
  border-radius: 12px;
  background-color: $color-background-base;
}

.title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  @include mobile-only {
    gap: 8px;
  }
}

.image {
  height: 120px;
  width: 120px;
  flex-shrink: 0;

  @include mobile-only {
    height: 64px;
    width: 64px;
  }
}

.text {
  font-size: 28px;
  line-height: 50.4px;
  font-weight: bold;

  @include mobile-only {
    font-size: 20px;
    line-height: 28px;
  }
}

.detail {
  font-size: 16px;
  line-height: 28.8px;

  @include mobile-only {
    margin-top: 16px;
    font-size: 14px;
  }
}
</style>
